export default class Modal {
    constructor(appContext){
        this.appContext = appContext
    }

    display(data){
        return new Promise((resolve, reject) => {
            this.appContext.$eventBus.$emit("modal-on", {
                data: data.data,
                component: data.component,
                resolve: resolve
            });
        })
    }

    dismiss(){
        this.appContext.$eventBus.$emit('modal-off')
    }
}